/* eslint-disable */
// Generated by apps/console/vite.config.ts for build profile "dev-fabric-vantage".
// DO NOT EDIT — rewritten on every profile build; gitignored. The committed
// composer (src/product-registry.ts) remains the full composition.
import {
  installExcludedRoutes,
  installProducts,
  isExcludedRoute,
} from '@bloo-team/core-shell'
import type { ConsoleProductManifest } from '@bloo-team/core-shell'
import { fabricManifest } from '@bloo-team/product-fabric/manifest'
import { vantageManifest } from '@bloo-team/product-vantage/manifest'

// Route paths this build does not carry — the ONE list this build states, and
// installed FIRST so the legacy redirect table stops pointing at them before
// anything renders (R6).
installExcludedRoutes(["/synthai/ask", "/synthai/investigations", "/synthai/actions", "/synthai/playbooks", "/synthai/knowledge", "/synthai/usage", "/synthai/sqlcheck", "/fabric/enrichment", "/vantage/hunts", "/vantage/response"])

// The rail is filtered from that same list, by destination. The route shim is
// already gone from the tree; filtering the manifest is what keeps the rail
// from rendering a link to it — the spike found the nav key still in the
// bundle with the page stripped, which is a visibly broken build, not a
// cosmetic one (R2). Filtering by `to` rather than by key means the rail and
// the redirect table can never disagree about what this build ships.
const withEnabledPages = (m: ConsoleProductManifest): ConsoleProductManifest => {
  const nav = m.nav.filter((entry) => !isExcludedRoute(entry.to))
  return nav.length === m.nav.length ? m : { ...m, nav }
}

export const PRODUCT_MANIFESTS: readonly ConsoleProductManifest[] = [
  fabricManifest,
  vantageManifest,
].map(withEnabledPages)

installProducts(PRODUCT_MANIFESTS)
